import {
  INBOX_V2_FEATURE,
  TEXTS_NOT_DELIVERED_FEATURE,
  UNANSWERED_TEXTS_FEATURE
} from "constants/feature-flags";
import { resolveNeedsReplyEnabled } from "features/inbox/needs-reply/use-needs-reply-enabled.hook";
import { resolveTextsNotDeliveredTabEnabled } from "features/inbox/texts-not-delivered/use-texts-not-delivered-enabled.hook";

import inSection from "./in-section.util";

export const INBOX_DESTINATIONS = inSection("/inbox", [
  // ENG-2223: the Unanswered Texts report inside the Inbox. Same gate as the red tab
  // that opens it (`useNeedsReplyEnabled`): the flag AND Inbox V2, for every practice.
  {
    to: "needs-reply",
    label: "Needs a reply",
    keywords: ["unanswered", "texts", "waiting", "reply", "region"],
    featureFlag: UNANSWERED_TEXTS_FEATURE,
    when: ({ flags }) =>
      resolveNeedsReplyEnabled(
        flags[UNANSWERED_TEXTS_FEATURE],
        flags[INBOX_V2_FEATURE]
      )
  },
  // Texts not delivered (Intercom 215476575290017). Same gate as the orange tab that opens it
  // (`useTextsNotDeliveredTabEnabled`): the flag AND Inbox V2.
  {
    to: "not-delivered",
    label: "Texts not delivered",
    keywords: ["undelivered", "landline", "failed", "sms", "texts", "delivery"],
    featureFlag: TEXTS_NOT_DELIVERED_FEATURE,
    when: ({ flags }) =>
      resolveTextsNotDeliveredTabEnabled(
        flags[TEXTS_NOT_DELIVERED_FEATURE],
        flags[INBOX_V2_FEATURE]
      )
  }
]);
